import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { toggleAudio, selectIsAudioEnabled } from "../../../app/actions/audio/audioSlice";

/**
 * オーディオトグルの共通制御。
 * Redux audioSlice の現在状態に基づき、ボタン描画に必要な要素一式を返す。
 */
const useAudioToggleControl = () => {
  const dispatch = useDispatch();
  const isAudioEnabled = useSelector(selectIsAudioEnabled);
  return {
    iconName: isAudioEnabled ? "volume_up" : "volume_off",
    ariaLabel: isAudioEnabled ? "オーディオを停止" : "オーディオを再生",
    onToggle: () => dispatch(toggleAudio()),
  };
};

/**
 * GlobalHeader 右端に並べる 40px 円形アイコンボタンの共通スタイル。
 * HeaderAudioToggle と HeaderShortcutHelp（? ボタン）で共有する。
 */
export const HeaderRoundIconButton = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid var(--soremo-border);
  border-radius: 50%;
  background-color: #fff;
  color: var(--soremo-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background-color 0.15s ease, transform 0.15s ease;

  &:hover {
    background-color: var(--soremo-background);
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const HeaderRoundIcon = styled.span`
  font-size: 20px;
  line-height: 1;
`;

/**
 * ヘッダー埋め込み版オーディオトグル
 * `GlobalHeader` の右端にインライン配置する小型ボタン。
 * 共通の `audioSlice` を制御する。
 */
export const HeaderAudioToggle = () => {
  const { iconName, ariaLabel, onToggle } = useAudioToggleControl();

  return (
    <HeaderRoundIconButton onClick={onToggle} aria-label={ariaLabel}>
      <HeaderRoundIcon className="material-symbols-rounded">{iconName}</HeaderRoundIcon>
    </HeaderRoundIconButton>
  );
};
